<template>
  <div id="menuBar">
    <div class="item" @click="change('Home')">
      <img src="@/assets/activeHome.png" alt="" v-if="active === 'Home'" />
      <img src="@/assets/home.png" alt="" v-else />
    </div>
    <div class="item" @click="change('RepayOrder')">
      <img src="@/assets/activeOrder.png" alt="" v-if="active === 'RepayOrder'" />
      <img src="@/assets/order.png" alt="" v-else />
    </div>
    <div class="item" @click="change('User')">
      <img src="@/assets/activeUser.png" alt="" v-if="active === 'User'" />
      <img src="@/assets/user.png" alt="" v-else />
    </div>
  </div>
</template>

<script>
export default {
  name: 'menuBar',
  data () {
    return {
      active: 'Home'
    }
  },
  created () {
    this.active = this.$route.name
  },
  methods: {
    change (e) {
      this.active = e
      this.$router.replace({ name: e })
    }
  }
}
</script>

<style scoped lang="less">
#menuBar {
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  display: flex;
  justify-content: space-around;
  padding: 22px 0;
  width: 100%;
  z-index: 99;
  img {
    width: 23px;
    height: 23px;
  }
}
</style>
